import { z } from 'zod'
import { l } from '@manychat/manyui'

export const KnowledgeValidation = {
  getTitleSchema: () =>
    z
      .string()
      .trim()
      .min(1, l.translate('Enter title to continue'))
      .max(
        60,
        l.translate('Title must be {count} characters or fewer', {
          count: 60,
        }),
      ),
}
